import Button from '@berlitz/button'
import { H1, H4 } from '@berlitz/globals'
import Modal from '@berlitzplatforms/micro.ui.modal'
import Spacer from '@berlitz/spacer'
import Info from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/14-Alerts/InformationCircle'
import { ActionButtons, CenterText } from '@components/Modal/style'
import Router from 'next/router'
import React from 'react'
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl'

interface RescheduleWarningModalProps {
  open: boolean
  onClose: Function
  onProceed?: Function
  rescheduleCount: number
  programId: string
}

const RescheduleWarningModal: React.FC<RescheduleWarningModalProps & InjectedIntlProps> = ({
  open,
  onClose,
  onProceed,
  rescheduleCount,
  programId,
}) => {
  let title = 'Re-schedule lesson'
  let header = <Info size="xl" color="info" />
  let subtitle = 'Please note: Your new lesson must be booked to override your old lesson'
  let footnote: any = (
    <H4>
      <FormattedMessage id="Reschedules remaining:" /> {rescheduleCount}
    </H4>
  )
  let actionButton = (
    <Button onClick={onProceed}>
      <FormattedMessage id="Re-schedule lesson" />
    </Button>
  )

  if (rescheduleCount < 1) {
    footnote = null
    title = 'You have reached the amount of lessons you can reschedule'
    subtitle = 'If you would like to purchase a re-schedule addon, please contact your learning center or raise a case.'
    header = <img src="/images/reschedule-addon.svg" alt="Empty learning centers" width="65%" />
    actionButton = (
      <Button
        onClick={() => {
          onClose()
          Router.push(`/support/contact-us/?id=my-lessons&pid=${programId}&cat=Add%20on%20products`)
        }}
      >
        <FormattedMessage id="Raise a case" />
      </Button>
    )
  }
  return (
    <Modal open={open} onClose={onClose}>
      <CenterText>
        <>
          {header}
          <Spacer size="lg" />
          <H1 disableMargin>
            <FormattedMessage id={title} />
          </H1>
          <H4>
            <FormattedMessage id={subtitle} />
          </H4>
          {footnote}

          <ActionButtons>
            <Button onClick={onClose}>
              <FormattedMessage id="Keep lesson" />
            </Button>
            {actionButton}
          </ActionButtons>
        </>
      </CenterText>
    </Modal>
  )
}

export default injectIntl(RescheduleWarningModal)
